import { en } from './en';

export type TranslationKeys = typeof en;

export const ta: TranslationKeys = {
  // Navigation
  nav: {
    home: 'முகப்பு',
    profile: 'சுயவிவரம்',
    schemes: 'திட்டங்கள்',
    applications: 'விண்ணப்பங்கள்',
    fraudCheck: 'மோசடி சரிபார்ப்பு',
    learnFinance: 'நிதி கற்றல்',
    appTitle: 'கிராமப்புற டிஜிட்டல் உரிமைகள்',
  },

  // Home Page
  home: {
    welcome: 'கிராமப்புற டிஜிட்டல் உரிமைகளுக்கு வரவேற்கிறோம்',
    subtitle: 'உங்களுக்கு ஏற்ற அரசு திட்டங்களைக் கண்டறியுங்கள்',
    getStarted: 'தொடங்குங்கள்',
    createProfile: 'உங்கள் சுயவிவரத்தை உருவாக்குங்கள்',
    browseSchemes: 'திட்டங்களை உலாவுங்கள்',
    checkEligibility: 'தகுதியை சரிபார்க்கவும்',
  },

  // Profile Page
  profile: {
    title: 'உங்கள் சுயவிவரம்',
    createTitle: 'உங்கள் சுயவிவரத்தை உருவாக்குங்கள்',
    updateTitle: 'உங்கள் சுயவிவரத்தை புதுப்பிக்கவும்',
    subtitle: 'தனிப்பயனாக்கப்பட்ட திட்ட பரிந்துரைகளைப் பெற எங்களிடம் உங்களைப் பற்றி சொல்லுங்கள்',
    personalInfo: 'தனிப்பட்ட தகவல்',
    age: 'வயது',
    gender: 'பாலினம்',
    male: 'ஆண்',
    female: 'பெண்',
    other: 'மற்றவை',
    caste: 'சாதி வகை',
    general: 'பொது',
    obc: 'ஓபிசி',
    sc: 'எஸ்சி',
    st: 'எஸ்டி',
    occupation: 'தொழில்',
    farmer: 'விவசாயி',
    laborer: 'தொழிலாளி',
    selfEmployed: 'சுய தொழில்',
    salaried: 'சம்பளம்',
    student: 'மாணவர்',
    unemployed: 'வேலையில்லாதவர்',
    incomeRange: 'ஆண்டு வருமான வரம்பு',
    below1lakh: '₹1 லட்சத்திற்கு கீழ்',
    '1to3lakh': '₹1-3 லட்சம்',
    '3to5lakh': '₹3-5 லட்சம்',
    '5to10lakh': '₹5-10 லட்சம்',
    above10lakh: '₹10 லட்சத்திற்கு மேல்',
    locationInfo: 'இடத் தகவல்',
    state: 'மாநிலம்',
    district: 'மாவட்டம்',
    pincode: 'பின்கோடு',
    saveProfile: 'சுயவிவரத்தை சேமிக்கவும்',
    updateProfile: 'சுயவிவரத்தை புதுப்பிக்கவும்',
    profileSaved: 'சுயவிவரம் வெற்றிகரமாக சேமிக்கப்பட்டது!',
    profileUpdated: 'சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
  },

  // Schemes Page
  schemes: {
    title: 'அரசு திட்டங்கள்',
    subtitle: 'நீங்கள் தகுதியுடைய திட்டங்களைக் கண்டறியுங்கள்',
    searchPlaceholder: 'திட்டங்களைத் தேடுங்கள்...',
    filters: 'வடிப்பான்கள்',
    category: 'வகை',
    level: 'நிலை',
    central: 'மத்திய',
    state: 'மாநில',
    allCategories: 'அனைத்து வகைகள்',
    agriculture: 'விவசாயம்',
    education: 'கல்வி',
    health: 'சுகாதாரம்',
    housing: 'வீட்டுவசதி',
    employment: 'வேலைவாய்ப்பு',
    socialWelfare: 'சமூக நலன்',
    viewDetails: 'விவரங்களைக் காண்க',
    applyNow: 'இப்போது விண்ணப்பிக்கவும்',
    eligibility: 'தகுதி',
    estimatedBenefit: 'மதிப்பிடப்பட்ட பலன்',
    match: 'பொருத்தம்',
    basedOnProfile: 'உங்கள் சுயவிவரத்தின் அடிப்படையில்',
    noSchemes: 'திட்டங்கள் எதுவும் கிடைக்கவில்லை',
    createProfileFirst: 'தனிப்பயனாக்கப்பட்ட பரிந்துரைகளைக் காண உங்கள் சுயவிவரத்தை உருவாக்கவும்',
    loading: 'திட்டங்கள் ஏற்றப்படுகின்றன...',
    interestedQuestion: 'இந்த திட்டத்தில் நீங்கள் ஆர்வமாக உள்ளீர்களா?',
    interestedMessage: 'பலன்களை எவ்வாறு பயன்படுத்துவது என்பது குறித்த தனிப்பயனாக்கப்பட்ட நிதி ஆலோசனையைப் பெற இந்த திட்டத்தை சேமிக்க விரும்புகிறீர்களா?',
    yesInterested: 'ஆம், எனக்கு ஆர்வம் உள்ளது',
    noThanks: 'இல்லை, நன்றி',
    saving: 'சேமிக்கப்படுகிறது...',
    noSchemesFound: 'திட்டங்கள் எதுவும் கிடைக்கவில்லை',
    noSchemesFilters: 'உங்கள் தற்போதைய வடிப்பான்களுடன் எந்த திட்டங்களும் பொருந்தவில்லை. உங்கள் தேடல் அல்லது வடிப்பான்களை சரிசெய்ய முயற்சிக்கவும்.',
    noSchemesAvailable: 'தற்போது எந்த திட்டங்களும் கிடைக்கவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.',
    clearFilters: 'வடிப்பான்களை அழிக்கவும்',
  },

  // Scheme Detail Dialog
  schemeDetail: {
    description: 'விளக்கம்',
    officialWebsite: 'அதிகாரப்பூர்வ இணையதளம்',
    helpline: 'உதவி எண்',
    close: 'மூடு',
    visitWebsite: 'அதிகாரப்பூர்வ இணையதளத்தைப் பார்வையிடவும்',
    callHelpline: 'உதவி எண்ணை அழைக்கவும்',
  },

  // Applications Page
  applications: {
    title: 'எனது விண்ணப்பங்கள்',
    subtitle: 'உங்கள் திட்ட விண்ணப்பங்களைக் கண்காணிக்கவும்',
    noApplications: 'இன்னும் விண்ணப்பங்கள் இல்லை',
    startApplying: 'அவற்றை இங்கே கண்காணிக்க திட்டங்களுக்கு விண்ணப்பிக்கத் தொடங்குங்கள்',
    status: 'நிலை',
    submittedOn: 'சமர்ப்பிக்கப்பட்டது',
    referenceNumber: 'குறிப்பு எண்',
    viewTimeline: 'காலவரிசையைக் காண்க',
  },

  // Fraud Check Page
  fraudCheck: {
    title: 'மோசடி கண்டறிதல்',
    subtitle: 'ஒரு செய்தி அல்லது அழைப்பு மோசடியா என்பதைச் சரிபார்க்கவும்',
    inputLabel: 'செய்தியை உள்ளிடவும் அல்லது அழைப்பை விவரிக்கவும்',
    inputPlaceholder: 'செய்தியை ஒட்டவும் அல்லது அழைப்பாளர் என்ன சொன்னார் என்பதை விவரிக்கவும்...',
    checkButton: 'மோசடியைச் சரிபார்க்கவும்',
    checking: 'பகுப்பாய்வு செய்யப்படுகிறது...',
    result: 'பகுப்பாய்வு முடிவு',
    safe: 'பாதுகாப்பானது',
    risky: 'ஆபத்தானது',
    safeMessage: 'இது சட்டபூர்வமானதாகத் தெரிகிறது',
    riskyMessage: 'இது சாத்தியமான மோசடியாகத் தெரிகிறது',
    explanation: 'விளக்கம்',
  },

  // Education/Learn Finance Page
  education: {
    title: 'நிதி கற்றல்',
    subtitle: 'உங்கள் ஆர்வமுள்ள திட்டங்களில் தனிப்பயனாக்கப்பட்ட நிதி ஆலோசனையைப் பெறுங்கள் மற்றும் பலன்களை எவ்வாறு சிறப்பாகப் பயன்படுத்துவது என்பதைக் கற்றுக்கொள்ளுங்கள்',
    overallPlan: 'ஒட்டுமொத்த நிதித் திட்டம்',
    overallPlanDesc: 'அனைத்திலிருந்தும் பலன்களை எவ்வாறு நிர்வகிப்பது மற்றும் பயன்படுத்துவது என்பது குறித்த விரிவான ஆலோசனையைப் பெறுங்கள்',
    schemesCount: 'திட்டங்கள் ஒன்றாக',
    getOverallAdvice: 'ஒட்டுமொத்த ஆலோசனையைப் பெறுங்கள்',
    yourSchemes: 'உங்கள் ஆர்வமுள்ள திட்டங்கள்',
    getAdvice: 'இந்த திட்டங்களிலிருந்து பலன்களை எவ்வாறு சிறப்பாகப் பயன்படுத்துவது என்பது குறித்த தனிப்பயனாக்கப்பட்ட நிதி ஆலோசனையைப் பெறுங்கள்',
    noSchemes: 'இன்னும் ஆர்வமுள்ள திட்டங்கள் இல்லை',
    noSchemesDesc: 'திட்டங்களை உலாவவும் மற்றும் தனிப்பயனாக்கப்பட்ட நிதி ஆலோசனையைப் பெற அவற்றை ஆர்வமாகக் குறிக்கவும்',
    getFinancialAdvice: 'நிதி ஆலோசனையைப் பெறுங்கள்',
    financialAdvice: 'நிதி ஆலோசனை',
    overallAdviceTitle: 'ஒட்டுமொத்த நிதித் திட்டம்',
    comprehensiveAdvice: 'க்கான விரிவான நிதி ஆலோசனை',
    combinedAnalysis: 'உங்கள் அனைத்து ஆர்வமுள்ள திட்டங்களின் ஒருங்கிணைந்த பகுப்பாய்வு',
    generatingAdvice: 'தனிப்பயனாக்கப்பட்ட நிதி ஆலோசனை உருவாக்கப்படுகிறது...',
    generatingPlan: 'விரிவான நிதித் திட்டம் உருவாக்கப்படுகிறது...',
    overallAdviceLabel: 'ஒட்டுமொத்த ஆலோசனை',
    keyPoints: 'முக்கிய புள்ளிகள்',
    utilizationTips: 'பலன்களை எவ்வாறு பயன்படுத்துவது',
    potentialImpact: 'சாத்தியமான தாக்கம்',
    removeScheme: 'திட்டத்தை அகற்று',
  },

  // Common
  common: {
    retry: 'மீண்டும் முயற்சிக்கவும்',
    loading: 'ஏற்றப்படுகிறது...',
    error: 'பிழை',
    success: 'வெற்றி',
    cancel: 'ரத்து செய்',
    confirm: 'உறுதிப்படுத்து',
    save: 'சேமி',
    delete: 'நீக்கு',
    edit: 'திருத்து',
    back: 'பின்',
    next: 'அடுத்து',
    submit: 'சமர்ப்பி',
    search: 'தேடு',
    filter: 'வடிப்பான்',
    clear: 'அழி',
    apply: 'பயன்படுத்து',
    close: 'மூடு',
  },
};
